export default "__VITE_ASSET__49VO1NIi__"